<!-- Upload -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="3 1.9978582859039307 19 20.00214195251465">
    <g class="primary-fill primary-stroke">
        <path stroke-width=".4" d="M12.43 3a.9.9 0 00-.535.2l-4.41 3.919A.807.807 0 007.42 8.19a.845.845 0 001.135-.008l3.1-2.756v10.716a.758.758 0 00.775.735.758.758 0 00.778-.735V5.427l3.1 2.756a.9.9 0 001.136.007.8.8 0 00-.065-1.072l-4.41-3.92a.776.776 0 00-.535-.2z"/>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M4 21h17"/>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M4 21v-3"/>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M21 21v-3"/>
    </g>
</svg>
